import BaseApi from '@lumapps/base-api';

import { LumappsUserFeedbackEvent } from '../types';

const userFeedbackApi = new BaseApi({ path: 'users/me/feedbacks', version: BaseApi.versions.v2 });

export const sendUserFeedback = async (event: LumappsUserFeedbackEvent) => {
    try {
        return await userFeedbackApi.post(
            '',
            { events: [event] },
            {
                validateStatus: (status: number) => status !== 400,
            },
        );
    } catch (err) {
        // eslint-disable-next-line no-console
        return console.error('An error occurred while sending user feedback event', { event, err });
    }
};
